/**
 * 华瑞保险出单接口
 * */

import { request } from '../util/request'

/**
 * @name CalculationUserInsure
 * @desc 计算保费
 * @param {object} data
 * @param {string} data.reserveData1  // 被保人生日
 * @param {string} data.insuranceProductCode
 * @param {number} data.
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function CalculationUserInsure(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/calculationUserInsure`,
    method: 'POST',
    data,
    loadingConfig
  })
}

// front/userInsuranceResource/checkUserInsureds
/**
 * @name CheckUserInusreds
 * @desc 多被保人投保校验
 * @param {object} data
 */
export function CheckUserInusreds(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/checkUserInsureds`,
    method: 'POST',
    data,
    loadingConfig
  })
}

/**
 * @name NewUserInsure
 * @desc 新增保单
 * @param {object} data
 * @param {string} data.appntIdNo
 * @param {string} data.appntIdType
 * @param {string} data.appntMobileNumber
 * @param {string} data.appntName
 * @param {string} data.effectiveDate
 * @param {string} data.endDate
 * @param {string} data.insuranceCompany
 * @param {string} data.insuranceName
 * @param {string} data.insurancePeriod
 * @param {string} data.insurancePlanCode
 * @param {string} data.insuranceProductCode
 * @param {number} data.insuredAmount
 * @param {string} data.insuredDateFlag
 * @param {number} data.insuredFeeAmount
 * @param {string} data.insuredPersonIdNo
 * @param {string} data.insuredPersonIdType
 * @param {string} data.insuredPersonName
 * @param {string} data.insuredPersonMobileNumber
 * @param {number} data.insuredTotalAmount
 * @param {number} data.insuredTotalFeeAmount
 * @param {number} data.numbers
 * @param {number} data.operateLogIdx
 * @param {number} data.payAmount
 * @param {string} data.payFrequencyFlag
 * @param {string} data.payFrequencyNumber
 * @param {string} data.polApplyDate
 * @param {string} data.renewalAccName
 * @param {string} data.renewalAccNo
 * @param {string} data.renewalBankCode
 * @param {string} data.startDate
 * @param {boolean} data.testFee
 * @param {string} data.thirdPolicyNo
 * @param {array} data.userInsureAdditionalList
 * @param {array} data.userInsurePayOrderEntities
 * @param {object[]} data.userInsurePersonList
 * @param {string} data.userInsurePersonList[].city
 * @param {string} data.userInsurePersonList[].insuredRelation
 * @param {string} data.userInsurePersonList[].personnelType
 * @param {string} data.userInsurePersonList[].province
 * @param {string} data.userInsurePersonList[].userCardNo
 * @param {string} data.userInsurePersonList[].userCardType
 * @param {string} data.userInsurePersonList[].userMobile
 * @param {string} data.userInsurePersonList[].userName
 * @param {object} data.userInsurePersonMap
 * @param {object} data.userInsurePersonMap.insured
 * @param {string} data.userInsurePersonMap.insured.city
 * @param {string} data.userInsurePersonMap.insured.insuredRelation
 * @param {string} data.userInsurePersonMap.insured.personnelType
 * @param {string} data.userInsurePersonMap.insured.province
 * @param {string} data.userInsurePersonMap.insured.userCardNo
 * @param {string} data.userInsurePersonMap.insured.userCardType
 * @param {string} data.userInsurePersonMap.insured.userMobile
 * @param {string} data.userInsurePersonMap.insured.userName
 * @param {object} data.userInsurePersonMap.policyHolder
 * @param {string} data.userInsurePersonMap.policyHolder.city
 * @param {string} data.userInsurePersonMap.policyHolder.insureNo
 * @param {string} data.userInsurePersonMap.policyHolder.insuredRelation
 * @param {string} data.userInsurePersonMap.policyHolder.personnelType
 * @param {string} data.userInsurePersonMap.policyHolder.province
 * @param {string} data.userInsurePersonMap.policyHolder.userCardNo
 * @param {string} data.userInsurePersonMap.policyHolder.userCardType
 * @param {string} data.userInsurePersonMap.policyHolder.userMobile
 * @param {string} data.userInsurePersonMap.policyHolder.userName
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function NewUserInsure(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/newUserInsure`,
    method: 'POST',
    data,
    loadingConfig
  })
}
/**
 * @name NewUserInsureWithOrder
 * @desc 湖南爱民保
 * */
export function NewUserInsureWithOrder(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/newUserInsureWithOrder`,
    method: 'POST',
    data,
    loadingConfig
  })
}
/**
 * @name newUserInsureWithOrderPolicy
 * @desc 湖南爱民保白名单
 * */
export function newUserInsureWithOrderPolicy(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/newUserInsureWithOrderPolicy`,
    method: 'POST',
    data,
    loadingConfig
  })
}
/**
 * @name ExamineUserInsure
 * @desc 核保
 * @param {object} data
 * @param {string} data.insuranceCompany  - GUO_RUI
 * @param {string} data.selfPolicySn
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */

export function ExamineUserInsure(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/examineUserInsure`,
    method: 'POST',
    data,
    loadingConfig
  })
}

/**
 * @name NewInsureSign
 * @desc 签单
 * @param {object} data
 * @param {string} data.selfPolicySn
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */

export function NewInsureSign(data, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/newInsureSign`,
    method: 'POST',
    data,
    loadingConfig
  })
}

/**
 * @name FindInsurancePolicyUrl
 * @desc 获取电子保单地址
 * @param {object} data
 * @param {string} data.selfPolicySn
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function FindInsurancePolicyUrl(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findInsurancePolicyUrl`,
    method: 'POST',
    data,
    loadingConfig
  })
}

/**
 * @name GetBasicData
 * @desc 获取保险基础数据 --  银行信息
 * @param {object} params
 * @param {string} params.insuranceCompany - GUO_RUI
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function GetBasicData(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/getBasicData`,
    method: 'get',
    params,
    loadingConfig
  })
}

// getAreaByParentCodeOfGH
/**
 * @name GetAreaByParentCodeOfGH
 * @desc 获取国瑞省市区地址
 * @param {object} params
 * @param {string} params.code
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function GetAreaByParentCodeOfGH(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/areaResource/getAreaByParentCodeOfGH`,
    method: 'get',
    params,
    loadingConfig
  })
}

// /services/front/userInsuranceResource/findUserInsuranceWithCompany
/**
 *
 * @name FindUserInsuranceWithCompany
 * @desc 保单理赔信息
 * @param {object} params
 * @param {string} params.insuanceId
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 *
 * */
export function FindUserInsuranceWithCompany(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findUserInsuranceWithCompany`,
    method: 'get',
    params,
    loadingConfig
  })
}

/**
 * @name FindUserInsuranceDetailForSettling
 * @desc 理赔保单详情
 * @param {object} params
 * @param {string} params.insuanceId
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function FindUserInsuranceDetailForSettling(
  params = {},
  loadingConfig = {}
) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findUserInsuranceDetailForSettling`,
    method: 'get',
    params,
    loadingConfig
  })
}

/**
 * @name GetInsurancePlanByCode
 * @desc 查询计划详情
 * @param {object} params
 * @param {string} params.productCode
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 *
 * */
export function GetInsurancePlanByCode(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/insurancePlanResource/getInsurancePlanByCode`,
    method: 'get',
    params,
    loadingConfig
  })
}

/**
 * @name getPdfUrlForChangAn
 * @desc 获取下载后的电子保单--长安责任
 * @param {string} data.selfPolicySn
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function getPdfUrlForChangAn(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/getPdfUrlForChangAn`,
    method: 'post',
    data,
    loadingConfig
  })
}
/**
 * @name NewUserInsureHNGift
 * @desc 新增赠险保单
 * @param {object} data
 * @param {string} data.appntIdNo
 * @param {string} data.appntIdType
 * @param {string} data.appntMobileNumber
 * @param {string} data.appntName
 * @param {string} data.effectiveDate
 * @param {string} data.endDate
 * @param {string} data.insuranceCompany
 * @param {string} data.insuranceName
 * @param {string} data.insurancePeriod
 * @param {string} data.insurancePlanCode
 * @param {string} data.insuranceProductCode
 * @param {number} data.insuredAmount
 * @param {string} data.insuredDateFlag
 * @param {number} data.insuredFeeAmount
 * @param {string} data.insuredPersonIdNo
 * @param {string} data.insuredPersonIdType
 * @param {string} data.insuredPersonName
 * @param {string} data.insuredPersonMobileNumber
 * @param {number} data.insuredTotalAmount
 * @param {number} data.insuredTotalFeeAmount
 * @param {number} data.numbers
 * @param {number} data.operateLogIdx
 * @param {number} data.payAmount
 * @param {string} data.payFrequencyFlag
 * @param {string} data.payFrequencyNumber
 * @param {string} data.polApplyDate
 * @param {string} data.renewalAccName
 * @param {string} data.renewalAccNo
 * @param {string} data.renewalBankCode
 * @param {string} data.startDate
 * @param {boolean} data.testFee
 * @param {string} data.thirdPolicyNo
 * @param {array} data.userInsureAdditionalList
 * @param {array} data.userInsurePayOrderEntities
 * @param {object[]} data.userInsurePersonList
 * @param {string} data.userInsurePersonList[].city
 * @param {string} data.userInsurePersonList[].insuredRelation
 * @param {string} data.userInsurePersonList[].personnelType
 * @param {string} data.userInsurePersonList[].province
 * @param {string} data.userInsurePersonList[].userCardNo
 * @param {string} data.userInsurePersonList[].userCardType
 * @param {string} data.userInsurePersonList[].userMobile
 * @param {string} data.userInsurePersonList[].userName
 * @param {object} data.userInsurePersonMap
 * @param {object} data.userInsurePersonMap.insured
 * @param {string} data.userInsurePersonMap.insured.city
 * @param {string} data.userInsurePersonMap.insured.insuredRelation
 * @param {string} data.userInsurePersonMap.insured.personnelType
 * @param {string} data.userInsurePersonMap.insured.province
 * @param {string} data.userInsurePersonMap.insured.userCardNo
 * @param {string} data.userInsurePersonMap.insured.userCardType
 * @param {string} data.userInsurePersonMap.insured.userMobile
 * @param {string} data.userInsurePersonMap.insured.userName
 * @param {object} data.userInsurePersonMap.policyHolder
 * @param {string} data.userInsurePersonMap.policyHolder.city
 * @param {string} data.userInsurePersonMap.policyHolder.insureNo
 * @param {string} data.userInsurePersonMap.policyHolder.insuredRelation
 * @param {string} data.userInsurePersonMap.policyHolder.personnelType
 * @param {string} data.userInsurePersonMap.policyHolder.province
 * @param {string} data.userInsurePersonMap.policyHolder.userCardNo
 * @param {string} data.userInsurePersonMap.policyHolder.userCardType
 * @param {string} data.userInsurePersonMap.policyHolder.userMobile
 * @param {string} data.userInsurePersonMap.policyHolder.userName
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function NewUserInsureHNGift(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/newUserInsureHNGift`,
    method: 'POST',
    data,
    loadingConfig
  })
}

/**
 * @name updatePersonCardNo
 * @desc 补全证件信息
 * @param {string} data.personId
 * @param {string} data.userCardNo
 * */
export function updatePersonCardNo(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/updatePersonCardNo`,
    method: 'post',
    data,
    loadingConfig
  })
}

/**
 * @name uploadFiles
 * @desc 上传
 * */
export function uploadFiles(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/orcUploadResource/uploadFiles`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data,
    loadingConfig
  })
}
/**
 * @name getCashValue
 * @desc 现价计算接口
 * */
export function getCashValue(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userSurrenderResource/getCashValue`,
    method: 'get',
    params,
    loadingConfig
  })
}
/**
 * @name surrenderRegisterCheck
 * @desc 数据校验接口
 * */
export function surrenderRegisterCheck(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userSurrenderResource/surrenderRegisterCheck`,
    method: 'post',
    data,
    loadingConfig
  })
}
/**
 * @name checkInsureOverdue
 * @desc 超期检测
 * */
export function checkInsureOverdue(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userSurrenderResource/checkInsureOverdue`,
    method: 'get',
    params,
    loadingConfig
  })
}
/**
 * @name findDictionaryByKey
 * @desc 银行列表
 * */
export function findDictionaryByKey(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/dict/findDictionaryByKey`,
    method: 'post',
    data,
    loadingConfig
  })
}
